import { useEffect } from "react";
import { getTotalFixedCost } from "../Redux/Actions/totalFixedCost";
import { getTotalYearGrossMargin } from "../Redux/Actions/totalYearGrossMargin";
import { getTotalAnnualSales } from "../Redux/Actions/totalAnnualSales";

export const TotalCostsGrossMarginAnnualSales = (
  fixedCostData,
  activeYear,
  dispatch,
  data
) => {
  //#region add all amounts in mixer and fixed cost, filter by year.
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      //"Fasta kostnader" total shown in dashboard
      function addTotalFixedCost() {
        try {
          const total = fixedCostData?.fixedCostData
            .filter((item) => item.year === activeYear.year)
            .map((item) => item.object.amount)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalFixedCost(total));
        } catch (err) {}
      }
      //"årstäckningsbidrag" total shown in dashboard
      function addTotalYearGrossMargin() {
        try {
          const total = data?.data
            .filter((item) => item.year === activeYear.year)
            .map(
              (item) =>
                //math formula: (price - variablecost) * volumeYear
                (parseFloat(item.object.price) -
                  parseFloat(item.object.variableCost)) *
                parseFloat(item.object.volumeYear)
            )
            //add sum of each row
            .reduce((acc, curr) => acc + parseFloat(curr, 10), 0);
          dispatch(getTotalYearGrossMargin(total));
        } catch (err) {}
      }
      // "årsförsäljning" total in dashboard
      function addTotalAnnualSales() {
        try {
          const total = data?.data
            .filter((item) => item.year === activeYear.year)
            .map(
              (item) =>
                //math formula: price * volumeYear
                parseFloat(item.object.price) *
                parseFloat(item.object.volumeYear)
            )
            //add sum of each row
            .reduce((acc, curr) => acc + parseFloat(curr, 10), 0);
          dispatch(getTotalAnnualSales(total));
        } catch (err) {}
      }
      addTotalFixedCost();
      addTotalYearGrossMargin();
      addTotalAnnualSales();
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear.year, data, dispatch, fixedCostData]);
  //#endregion add all amounts of mixer and fixed cost filter by year.
};
